import { noop } from 'lodash';
import React, { useRef } from 'react';

export type HeadersContext = Record<string, string>;

type AddVaryHeaders = (headers: string[]) => void;
type SetVaryHeaders = (headers: string[]) => void;
type SetHeader = (key: string, value: string) => void;

interface ResponseHeadersContextValue {
  addVaryHeaders: AddVaryHeaders;
  setVaryHeaders: SetVaryHeaders;
  setHeader: SetHeader;
  headers: HeadersContext;
}

export const ResponseHeadersContext = React.createContext<ResponseHeadersContextValue>({
  addVaryHeaders: noop,
  setVaryHeaders: noop,
  setHeader: noop,
  headers: {}
});

const ResponseHeadersProvider: React.FC<React.PropsWithChildren<{ context: HeadersContext }>> = ({
  children,
  context
}) => {
  const varyHeaders = useRef<Set<string>>(new Set());

  const setHeader: SetHeader = (key: string, value: string) => (context[key] = value);
  const setVaryHeader = () => setHeader('vary', Array.from(varyHeaders.current).join(', '));

  const addVaryHeaders: AddVaryHeaders = (headers) => {
    headers.forEach((header) => varyHeaders.current.add(header));
    setVaryHeader();
  };

  const setVaryHeaders: SetVaryHeaders = (headers) => {
    varyHeaders.current = new Set(headers);
    setVaryHeader();
  };

  return (
    <ResponseHeadersContext.Provider
      value={{ addVaryHeaders, setVaryHeaders, setHeader, headers: context }}
    >
      {children}
    </ResponseHeadersContext.Provider>
  );
};

export default ResponseHeadersProvider;
